import { useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import { Link } from "react-router-dom";
import Logo from "./../assets/Logo.png";

type Props = {
    children: React.ReactNode;
    to: string;
};

type Link = {
    url: string;
    label: string;
};

const Links: Link[] = [
    { url: "/howitworks", label: "How it works" },
    //{ url: "/pricing", label: "Pricing" },
    { url: "/connect", label: "Connect" },
];

const NavLink = ({ children, to, onClick }: Props & { onClick?: () => void }) => {
    return (
        <li>
            <RouterLink
                to={to}
                className={({ isActive }) =>
                    `flex px-4 py-2 items-center ${
                        isActive
                            ? "text-neonGreen font-bold"
                            : "text-gray30 font-bold hover:text-neonGreen"
                    }`
                }
                onClick={onClick}
            >
                {children}
            </RouterLink>
        </li>
    );
};


function NavBar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    return (
        <div className="sticky top-0 backdrop-blur-sm top-4 bg-[rgba(0,0,0,0.4)] w-11/12 xl:w-11/12 rounded-full h-14 mx-5 px-14 flex justify-between items-center z-50">
            <RouterLink to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className={"flex flex-row"}>
                <img src={Logo} className="w-24 h-auto" />
                <span className="text-white text-[5px] pt-[5%]">TM</span>
            </RouterLink>

            <ul className="hidden md:flex flex-row space-x-4">
                {Links.map((link) => (
                    <NavLink key={link.url} to={link.url} onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                        <span>{link.label}</span>
                    </NavLink>
                ))}
            </ul>

            <div className="hidden md:flex items-center space-x-4">
                {/*<Link
                    to="/signup"
                    className="text-gray30 text-base font-bold hover:text-neonGreen text-center"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                >
                    Sign up
                </Link>*/}
                <div className="flex bg-neonGreen py-2.5 px-3.5 rounded-full hover:bg-gray text-black hover:text-white">
                    <a
                        href="https://app.onxite.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-black font-bold hover:text-white"
                    >
                        Sign in
                    </a>
                </div>
            </div>

            <button
                onClick={toggleMenu}
                className="md:hidden focus:outline-none"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 6h16M4 12h16M4 18h16"
                    />
                </svg>
            </button>

            {isMenuOpen && (
                <div className="absolute top-16 left-0 w-full bg-secondBlack bg-opacity-95 z-40 rounded-lg shadow-lg md:hidden">
                    <ul className="flex flex-col items-center space-y-4 py-4">
                        {Links.map((link) => (
                            <NavLink key={link.url} to={link.url}>
                                <span>{link.label}</span>
                            </NavLink>
                        ))}
                        {/*<Link
                            to="/signup"
                            className="text-gray30 text-base font-bold hover:text-neonGreen"
                        >
                            Sign up
                        </Link>*/}
                        <div className="bg-neonGreen py-2.5 px-3.5 rounded-full">
                            <a
                                href="https://app.onxite.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-black font-bold"
                            >
                                Sign in
                            </a>
                        </div>
                    </ul>
                </div>
            )}
        </div>
    );
}

export default NavBar;
